
import { SavedQuery } from '#search/model'
import { SubmissionIcon, submissionPlural, submissionSingular, submissionType } from '#submission/constants'
import { SubmissionLabel } from '#submission/label'
import { Submission } from '#submission/model'
import { approveSubmission, editSubmission, manageSubmission, publishSubmission } from '#submission/oracle'
import { do_anything, getActions } from 'apprise-core/action'
import { User } from 'apprise-core/user'
import { utils } from 'apprise-core/utils'
import { FormState } from 'apprise-frontend-core/utils/form'
import { useOracle } from 'apprise-frontend-iam/authz/oracle'
import { PermissionBox, PermissionBoxProps } from 'apprise-frontend-iam/permission/permissionbox'
import { UserPermissionModule, UserPreferencesModule } from 'apprise-frontend-iam/user/modules'
import { usePreferences } from "apprise-frontend-iam/user/preferences"
import { MailTopicBox } from 'apprise-frontend-mail/mailtopicbox'
import { MailTopic } from 'apprise-frontend-mail/model'



// ----preferences -------------------------------------------------------------------------------------------------------------------


export type RavUserPreferences = RavUserMailProfile & {

    // these are not set in the user form, but indirectly through table drawers.
    search: {

        columns: React.Key[],

        queries: SavedQuery[]
    }

}

export type RavUserMailProfile = {

    // these are set in the user form.
    mailProfile: {

        topics: MailTopic[]
    }
}


export const defaultPreferences: RavUserPreferences = {

    search: {

        columns: [],
        queries: []
    },

    mailProfile: {

        topics: []
    }
}

export const useRavPreferences = () => {

    const preferences = usePreferences<RavUserPreferences>()

    const self = {

        ...preferences,

        get: () => utils().merge(defaultPreferences, preferences.get())

    }

    return self
}


const Form = (props: FormState<User>) => {

    const { edited, set } = props

    const prefs = utils().merge(defaultPreferences, edited.details.preferences) as RavUserPreferences

    return <>

        <MailTopicBox onChange={set.with((m, v) => {

            const profile: RavUserMailProfile = { mailProfile: { ...prefs.mailProfile, topics: v } }

            m.details.preferences = { ...prefs, ...profile }


        })}>
            {prefs.mailProfile?.topics}
        </MailTopicBox>

    </>
}

export const userPreferencesModule: UserPreferencesModule = {
    Form
}


// permissions
// -----------------------------------------------------------------------------------------------------------------------------------




export const useSubmissionPermissionModule = (): UserPermissionModule<Submission> => {

    const oracle = useOracle()

    const actions = getActions()

    return {

        type: submissionType,
        plural: submissionPlural,

        Icon: SubmissionIcon,

        initial: (user: User) => {

            const u = oracle.given(user)

            return u.hasNoTenant() ? [actions.instantiate(do_anything)] : [actions.instantiate(manageSubmission)]

        },

        // 08/25: this has been modelled
        actions: [

            { ...manageSubmission, shortName: "action.manage_short", name: "action.manage_name", description: "action.manage_desc" },
            { ...editSubmission, shortName: "action.edit_short", name: "action.edit_name", description: "action.edit_desc" },
            { ...publishSubmission, virtual: true, shortName: "action.publish_short", name: "action.publish_name", description: "action.publish_desc" },
            { ...approveSubmission, virtual: true, shortName: "action.approve_short", name: "action.approve_name", description: "action.approve_desc" }
        ],


        Box: (props: Partial<PermissionBoxProps<Submission>>) => {

            return <PermissionBox<Submission> {...props}

                maxPrivilege={manageSubmission}

                resourceSingular={submissionSingular}
                resourcePlural={submissionPlural}
                resourceId={s => s.id}
                resourceRender={s => <SubmissionLabel bare submission={s} />}
                tenantResource

                wildcard preselectWildcard />

        }
    }


}